export default {
    methods: {
        setDefault(key, value){
            if(this.settings[key] === undefined){
                Vue.set(this.settings, key, value);
            }
        },
    },
    props: [
        'value',
    ],
    data(){
        return {
            settings: {},
        }
    },
    beforeMount(){
        console.log('______beforeMount', this.value)
        this.$set(this, 'settings', this.value);
    },
    watch: {
        value(){
            this.$set(this, 'settings', this.value);
        },
        settings: {
            deep: true,
            handler(newVal, oldVal){
                if(JSON.stringify(newVal) !== JSON.stringify(oldVal)){
                    this.$emit('input', JSON.parse(JSON.stringify(newVal)));
                }
            }
        },
    },
}